<template>
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      data: {
        verifyStatus: '', // 审核状态
        auditor: '未一审', // 一审人
        auditor2: '未二审', // 二审人
        verifyDate1: '', // 一审时间
        verifyDate2: '' // 二审时间
      },
      options: [
        {
          name: 'verifyStatus',
          note: '审核状态',
          type: 'String',
          disabled: true
        },
        {
          name: 'auditor',
          note: '一审操作人',
          type: 'String',
          disabled: true
        },
        {
          name: 'verifyDate1',
          note: '一审时间',
          type: 'Date',
          disabled: true
        },
        {
          name: 'auditor2',
          note: '二审操作人',
          type: 'String',
          disabled: true
        },
        {
          name: 'verifyDate2',
          note: '二审时间',
          type: 'Date',
          disabled: true
        },
      ]
    }
  },
  async created () {
    let { data: res } = await this.$tkParse.get('/classes/Order', {
      params: {
        where: {
          objectId: this.record.objectId
        }
      }
    })
    if (res.results[0].verifyStatus === 'noVerify') {
      this.data.verifyStatus = '待审核'
    }
    if (res.results[0].verifyStatus === 'firstVerify') {
      this.data.verifyStatus = '待二审'
      this.data.verifyDate1 = res.results[0].verifyDate1
      this.data.auditor = res.results[0].auditor
    }
    if (res.results[0].verifyStatus === 'secondVerify') {
      this.data.verifyStatus = '审完成'
      this.data.verifyDate1 = res.results[0].verifyDate1
      this.data.verifyDate2 = res.results[0].verifyDate2
      this.data.auditor = res.results[0].auditor
      this.data.auditor2 = res.results[0].auditor2
    }
  },
  methods: {
    submit () {
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    },
    cancel () {
      this.$emit('complete', 'cancel')
    },
  },
  props: {
    vm: Object,
    record: Object, // 当前行的数据
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    title: String
  }
}
</script>

<style>

</style>
